<template>
  <header class="p-3">
    <div class="header-area header-login">
      <router-link to="/" class="d-flex align-items-center mb-2 mb-md-0 text-white text-decoration-none col-6 col-md-auto">
        <img :src="Logo" width="100" />
      </router-link>
      <nav class="navbar navbar-light p-0">
        <div class="d-flex col-12 col-md-3 col-lg-2 flex-wrap flex-md-nowrap justify-content-between">
          <button class="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebar"
            aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list"
              viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
            </svg>
          </button>
        </div>
      </nav>

      <ul class="nav col-6 col-md-auto ms-md-auto me-md-3 ms-md-auto justify-content-end">
        <li><router-link to="/" class="nav-link px-2">HOME</router-link></li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
            メニュー
          </a>
          <ul class="dropdown-menu">
            <li><router-link class="dropdown-item" to="/static/entry">新規登録方法のご案内</router-link></li>
            <li><router-link class="dropdown-item" to="/static/confirmation">シーズンプログラム予約前確認事項</router-link></li>
            <li><router-link class="dropdown-item" to="/static/cancel">シーズンプログラムキャンセル規定</router-link></li>
            <li><router-link class="dropdown-item" to="/static/annual-confirmation">通年プログラム予約前確認事項</router-link></li>
            <li><router-link class="dropdown-item" to="/static/annual-cancel">通年プログラムキャンセル規定</router-link></li>
            <li><router-link class="dropdown-item" to="/static/faq">よくあるご質問</router-link></li>
            <li><router-link class="dropdown-item" to="/inquiry/index">お問い合わせ</router-link></li>
            <li><router-link class="dropdown-item" to="/static/friendshipfund">フレンドシップファンドのご案内</router-link></li>
            <li><a class="dropdown-item" target="_blank" href="https://tokyo.ymca.or.jp/">東京YMCAホームページ</a></li>
          </ul>
        </li>
        <li><router-link to="/search/index" class="nav-link px-2">検索</router-link></li>
      </ul>

      <div class="header-btn-area col-auto ms-auto ms-md-0">
        <router-link to="" @click="logout" class="btn btn-header login"><i
            class="bi bi-box-arrow-left"></i>ログアウト</router-link>
        <router-link to="/mypage/index" class="btn btn-header"><i class="bi bi-person"></i>マイページ</router-link>
      </div>

      <div class="col-auto ms-auto ms-md-3 header-id">
        <p class="mb-0">ID:{{ memberStore.id }}<br>{{ memberStore.name }} 様</p>
      </div>
    </div>
  </header>
  <nav id="sidebar" class="mypage-contents_menu col-12 sidebar collapse">
    <div class="position-sticky">
      <ul class="nav">
        <li class="nav-item">
          <router-link to="/mypage/index" class="nav-link" :class="{ 'active': isActive('/mypage/index') }" aria-current="page">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-house"
              viewBox="0 0 16 16">
              <path
                d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
            </svg>
            <span class="ml-2">マイページ</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/search/index" class="nav-link" :class="{ 'active': isActive('/search/index') }">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-search"
              viewBox="0 0 16 16">
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
            <span class="ml-2">検索</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/mypage/schedule">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
              class="bi bi-calendar-event" viewBox="0 0 16 16">
              <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
              <path
                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
            </svg>
            <span class="ml-2">過去参加プログラム</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/mypage/favorite" class="nav-link" :class="{ 'active': isActive('/mypage/password/form') || isActive('/mypage/password/complete')}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
              <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"/>
            </svg>
            <span class="ml-2">お気に入り</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/mypage/profile/index" class="nav-link" :class="{ 'active': isActive('/mypage/profile/index') }">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person-gear"
              viewBox="0 0 16 16">
              <path
                d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
            </svg>
            <span class="ml-2">アカウント編集</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/mypage/password/form" class="nav-link" :class="{ 'active': isActive('/mypage/password/form') || isActive('/mypage/password/complete')}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-lock"
              viewBox="0 0 16 16">
              <path
                d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
            </svg>
            <span class="ml-2">パスワード変更</span>
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" href="/mypage/social/index.php">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-line"
              viewBox="0 0 16 16">
              <path
                d="M8 0c4.411 0 8 2.912 8 6.492 0 1.433-.555 2.723-1.715 3.994-1.678 1.932-5.431 4.285-6.285 4.645-.83.35-.734-.197-.696-.413l.003-.018.114-.685c.027-.204.055-.521-.026-.723-.09-.223-.444-.339-.704-.395C2.846 12.39 0 9.701 0 6.492 0 2.912 3.59 0 8 0ZM5.022 7.686H3.497V4.918a.156.156 0 0 0-.155-.156H2.78a.156.156 0 0 0-.156.156v3.486c0 .041.017.08.044.107v.001l.002.002.002.002a.154.154 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157Zm.791-2.924a.156.156 0 0 0-.156.156v3.486c0 .086.07.155.156.155h.562c.086 0 .155-.07.155-.155V4.918a.156.156 0 0 0-.155-.156h-.562Zm3.863 0a.156.156 0 0 0-.156.156v2.07L7.923 4.832a.17.17 0 0 0-.013-.015v-.001a.139.139 0 0 0-.01-.01l-.003-.003a.092.092 0 0 0-.011-.009h-.001L7.88 4.79l-.003-.002a.029.029 0 0 0-.005-.003l-.008-.005h-.002l-.003-.002-.01-.004-.004-.002a.093.093 0 0 0-.01-.003h-.002l-.003-.001-.009-.002h-.006l-.003-.001h-.004l-.002-.001h-.574a.156.156 0 0 0-.156.155v3.486c0 .086.07.155.156.155h.56c.087 0 .157-.07.157-.155v-2.07l1.6 2.16a.154.154 0 0 0 .039.038l.001.001.01.006.004.002a.066.066 0 0 0 .008.004l.007.003.005.002a.168.168 0 0 0 .01.003h.003a.155.155 0 0 0 .04.006h.56c.087 0 .157-.07.157-.155V4.918a.156.156 0 0 0-.156-.156h-.561Zm3.815.717v-.56a.156.156 0 0 0-.155-.157h-2.242a.155.155 0 0 0-.108.044h-.001l-.001.002-.002.003a.155.155 0 0 0-.044.107v3.486c0 .041.017.08.044.107l.002.003.002.002a.155.155 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156Z" />
            </svg>
            <span class="ml-2">LINE連携</span>
          </a>
        </li> -->
        <li class="nav-item">
          <router-link to="/mypage/withdrawal" class="nav-link" :class="{ 'active': isActive('/mypage/withdrawal')}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person-x" viewBox="0 0 16 16">
              <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"/>
              <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"/>
            </svg>
          <span class="ml-2">退会</span>
        </router-link>
        </li>
        <li class="nav-item">
          <router-link to="" @click="logout" class="nav-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
            class="bi bi-box-arrow-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z" />
            <path fill-rule="evenodd"
              d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z" />
          </svg>
          <span class="ml-2">ログアウト</span>
        </router-link>
        </li>
      </ul>
      <router-link class="nav-link" to="/static/entry">新規登録方法のご案内</router-link>
      <router-link class="nav-link" to="/static/confirmation">シーズンプログラム予約前確認事項</router-link>
      <router-link class="nav-link" to="/static/cancel">シーズンプログラムキャンセル規定</router-link>
      <router-link class="nav-link" to="/static/annual-confirmation">通年プログラム予約前確認事項</router-link>
      <router-link class="nav-link" to="/static/annual-cancel">通年プログラムキャンセル規定</router-link>
      <router-link class="nav-link" to="/static/faq">よくあるご質問</router-link>
      <router-link class="nav-link" to="/inquiry/index">お問い合わせ</router-link>
      <router-link class="nav-link" to="/static/friendshipfund">フレンドシップファンドのご案内</router-link>
      <a class="nav-link" target="_blank" href="https://tokyo.ymca.or.jp/">東京YMCAホームページ</a>
    </div>
  </nav>
</template>


<script setup lang="ts">
import { API } from '../../api'
import Logo from '@/images/logo.svg'
import { useMemberStore } from '@/stores/member'
import { useRouter } from 'vue-router'

const memberStore = useMemberStore()
const router = useRouter()

const isActive = (linkPath) => {
      return router.currentRoute.value.path === linkPath;
    };

 const withdrawal = () => {
  const result = confirm("退会しますか？")
  if(result){
    API.delete('/api/withdrawal', {
      params: {
        id: useMemberStore().$state.id,
        address: useMemberStore().$state.mailAddress
      }
    })
      .then(response => {
        if (response.data.status == "success") {
          useMemberStore().logout()
          router.push('/');
        } else {
        }
      })
      .catch(error => {
        const errKey = Object.keys(error.response.data.errors)[0]
        console.error(error.response.data.errors[errKey][0])
      })
    }
 }

const logout = () => {
  API.get('/api/logout', {
    params: {
      id: useMemberStore().$state.id,
      address: useMemberStore().$state.mailAddress
    }
  })
    .then(response => {
      if (response.data.status == "success") {
        useMemberStore().logout()
        router.push('/');
      } else {
      }
    })
    .catch(error => {
      const errKey = Object.keys(error.response.data.errors)[0]
      console.error(error.response.data.errors[errKey][0])
    })
}
</script>